module.exports = __webpack_public_path__ + "static/bbis-laundry-min-6d6878b52851e0e376c12cce3553c0be.jpg";